export class SnowflakeBigfoot {
  private _date: Element;
  private _facebook: Element;
  private _linkedin: Element;
  private _twitter: Element;

  init () {
    this._date = document.getElementById('current-year');
    this._facebook = document.getElementById('link-facebook');
    this._linkedin = document.getElementById('link-linkedin');
    this._twitter = document.getElementById('link-twitter');

    this._date.innerHTML = new Date().getFullYear().toString();

    const currentUrl = window.location.href;
    const facebookLink = '//www.facebook.com/sharer.php?u=' + currentUrl;
    const linkedinLink = '//www.linkedin.com/shareArticle?mini=true&url=' + currentUrl;
    const twitterLink = '//twitter.com/share?url=' + currentUrl;

    this._facebook.setAttribute('href', facebookLink );
    this._linkedin.setAttribute('href', linkedinLink );
    this._twitter.setAttribute('href', twitterLink );
  }

  constructor ( ) {}
}
